import { IconProps } from "../../models/Icon";

export function InformationIcon({ size = 20, color = "#FAAD14", opacity = "1" }: IconProps) {

  return (

    <svg 
        width={size} 
        height={size} 
        viewBox="0 0 24 25" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M12 2C6.20156 2 1.5 6.70156 1.5 12.5C1.5 18.2984 6.20156 23 12 23C17.7984 23 22.5 18.2984 22.5 12.5C22.5 6.70156 17.7984 2 12 2ZM12 21.2188C7.18594 21.2188 3.28125 17.3141 3.28125 12.5C3.28125 7.68594 7.18594 3.78125 12 3.78125C16.8141 3.78125 20.7188 7.68594 20.7188 12.5C20.7188 17.3141 16.8141 21.2188 12 21.2188Z"
            fill={color}
        />
        <path 
            opacity="0.1" 
            d="M12 3.78125C7.18594 3.78125 3.28125 7.68594 3.28125 12.5C3.28125 17.3141 7.18594 21.2188 12 21.2188C16.8141 21.2188 20.7188 17.3141 20.7188 12.5C20.7188 7.68594 16.8141 3.78125 12 3.78125ZM12.75 17.5625C12.75 17.6656 12.6656 17.75 12.5625 17.75H11.4375C11.3344 17.75 11.25 17.6656 11.25 17.5625V11.1875C11.25 11.0844 11.3344 11 11.4375 11H12.5625C12.6656 11 12.75 11.0844 12.75 11.1875V17.5625ZM12 9.5C11.7056 9.49399 11.4253 9.37282 11.2192 9.1625C11.0132 8.95218 10.8977 8.66945 10.8977 8.375C10.8977 8.08055 11.0132 7.79782 11.2192 7.5875C11.4253 7.37718 11.7056 7.25601 12 7.25C12.2944 7.25601 12.5747 7.37718 12.7808 7.5875C12.9868 7.79782 13.1023 8.08055 13.1023 8.375C13.1023 8.66945 12.9868 8.95218 12.7808 9.1625C12.5747 9.37282 12.2944 9.49399 12 9.5Z" 
            fill={color}
        />
        <path 
            d="M10.875 8.375C10.875 8.67337 10.9935 8.95952 11.2045 9.1705C11.4155 9.38147 11.7016 9.5 12 9.5C12.2984 9.5 12.5845 9.38147 12.7955 9.1705C13.0065 8.95952 13.125 8.67337 13.125 8.375C13.125 8.07663 13.0065 7.79048 12.7955 7.5795C12.5845 7.36853 12.2984 7.25 12 7.25C11.7016 7.25 11.4155 7.36853 11.2045 7.5795C10.9935 7.79048 10.875 8.07663 10.875 8.375ZM12.5625 11H11.4375C11.3344 11 11.25 11.0844 11.25 11.1875V17.5625C11.25 17.6656 11.3344 17.75 11.4375 17.75H12.5625C12.6656 17.75 12.75 17.6656 12.75 17.5625V11.1875C12.75 11.0844 12.6656 11 12.5625 11Z" 
            fill={color}
        />
    </svg>

  )
}